import React from "react";

import SearchInputsConfig from "../../../../config/webgeo/SearchInputsConfig";
import { Input } from "../../../global";

interface ISearchInputs {
    input: string;
}

export const SearchInputs: React.FC<ISearchInputs> = ({ input }) => {
    const inputConfig = SearchInputsConfig[input];

    if (!inputConfig) return null;

    return (
        <div className="flex flex-col" key={input}>
            <Input
                name={input}
                label={inputConfig.label}
                icon={inputConfig.icon}
            />
        </div>
    );
};
